import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Oswald\",\"arguments\":[{\"variable\":\"--font-oswald\",\"subsets\":[\"latin\"],\"display\":\"swap\",\"weight\":[\"400\",\"700\"]}],\"variableName\":\"oswald\"}");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"variable\":\"--font-roboto\",\"subsets\":[\"latin\"],\"weight\":[\"400\"],\"display\":\"swap\",\"adjustFontFallback\":true}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager" */ "/workspace/public/petrolboys-colored.svg");
;
import(/* webpackMode: "eager" */ "/workspace/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/workspace/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/workspace/src/components/header/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StickyBoxContainer"] */ "/workspace/src/components/sticky-box/sticky-box-container.tsx");
